const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/layout/RedirectWithQueryParams.tsx';
import { Redirect } from 'react-router';

import { isSecuredLocationPath } from 'App/utils/urlLocationCheck';
import { PATH_DASHBOARD } from 'App/defs/router';
import { useFeatureFlags } from 'App/store/featureFlags';
import { storeInvitationCode } from 'App/actions/ui';
import { useDispatch } from 'react-redux';

/**
 * Redirects unknown top-level paths, taking the query params into account
 */
export const RedirectWithQueryParams = () => {
    const { data: featureFlags } = useFeatureFlags();
    const dispatch = useDispatch<any>();

    // NOTE: Query params behind the # may be accessed with the useLocation hook, but we neeed the query params in
    // front of #, so we use location directly:
    const query = new URLSearchParams(location.search);
    const invitationCode = query.get('invitationcode');

    // little hack since usp-ses doesnt redirect to secured/login/#/app/dashboard but to secured/login/#/ if user has to login
    // the second login where session-cookies are already, where to user doesnt need to enter email/pw/challenge, then it redirects correctly to app/dashboard
    if (isSecuredLocationPath()) {
        return <Redirect to={PATH_DASHBOARD} />;
    }
    // NOTE: The Redirect component never changes the query params in front of the #. To avoid that these query params
    // stay forever in the url, we call replaceState directly, bypassing react-router. This will probably be unnecessary
    // if we sometime use regular routes rather than hash routes.

    if (invitationCode) {
        dispatch(storeInvitationCode(invitationCode));

        const url = [
            location.toString().split('?')[0],
            '#/app/login/invitation-code',
            `?invitationcode=${invitationCode}`,
        ].join('');
        history.replaceState(null, '', url);
        return null;
    }

    // Other unknown urls lead back to the welcome page.
    return featureFlags.login.allowIAM ? <Redirect to="/app/start" /> : <Redirect to="/app/login/invitation-code" />;
};
